import React from 'react'
import { Button } from './components/button';
import { Header } from './components/header';
import { InputAmount } from './components/inputAmount';
import { ButtonConfig, QuotaState } from 'interfaces/quota';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'context';
import { quotaFormula } from 'utils/quotaFormula';
import { setQuotas } from 'context/reducer/quota';
import { AppState } from '../../../../../interfaces/app/index';

export const Amount: React.FC = () => {

    const { amount } = useSelector<RootState, QuotaState>((state) => state.quota)
    const { isMobile } = useSelector<RootState, AppState>((state) => state.app)

    const dispatch = useDispatch()

    const calculateAmount = (amountRaw: string) => {
        const amountConverted = amountRaw
        if (amountConverted === '0') return '';
        if (parseInt(amountConverted.replace('.', ''),10) < 0) return '300'
        if (parseInt(amountConverted.replace('.', ''),10) > 40000) return '40000'
        return (amountConverted)
    }
    
    const disableSimulatorButton = amount === '' || amount === 'NaN' || !amount

    const handleOnClickSimulate = () => {
        const data = quotaFormula(calculateAmount(amount))
        dispatch(setQuotas(data))
    }

    const confirmButtonConfig: ButtonConfig = {
        color: 'complementary',
        value: 'Simular',
        disabled: disableSimulatorButton,
        action: handleOnClickSimulate
    }

    return (
        <div className={`${!isMobile ? 'size-simulator bp-p-24' : 'bp-mt-4'}`}>
            <Header />
            <InputAmount />
            <Button confirmButtonConfig={confirmButtonConfig} />
        </div>
    );

}
